import { createSlice } from "@reduxjs/toolkit";
import { defaultLayout } from "providers/layout/Layout";
import userSettingsSlice from "./user/userSettingsSlice";
import { scopeSlice } from "services/store/scopeSlice";

const layoutSlice = createSlice({
    name: "layout",
    initialState: defaultLayout,
    reducers: {
        toggleNavbar: (state) => {
            state.navbar = state.navbar === "visible" ? "hidden" : "visible";
        },
        toggleSider: (state) => {
            state.siderVisible = !state.siderVisible;
        },
        toggleSidebarExpanded: (state) => {
            state.isSidebarExpanded = !state.isSidebarExpanded;
        },
        toggleMobileSider: (state) => {
            state.isMobileSiderShowing = !state.isMobileSiderShowing;
        },
        toggleBackground: (state) => {
            state.background = state.background === "dark" ? "light" : "dark";
        },
        setLayout: (state, action) => {
            Object.assign(state, action.payload);
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(userSettingsSlice.actions.get, (state, action) => {
            if (action?.payload?.data?.settings?.interface?.darkMode) {
                state.darkMode = action?.payload?.data?.settings?.interface?.darkMode;
            }
        })
        .addCase(userSettingsSlice.actions.localUpdate, (state, action) => {
            if (action?.payload?.interface) {
                state.darkMode = action?.payload?.interface?.darkMode;
            }
        })
        .addCase(userSettingsSlice.actions.update, (state, action) => {
            if (action?.payload?.data?.settings?.interface?.darkMode) {
                state.darkMode = action?.payload?.data?.settings?.interface?.darkMode;
            }
        })
        .addCase(scopeSlice.actions.logout, (state) => {
            state = defaultLayout;
        })
    }
});

export const layoutSelector = (state: any) => state.layout;

export default layoutSlice;